export default {
  FIELDS_PANEL_OPTION: 'FIELDS_PANEL_OPTION',
  PAGE_FIELD: 'PAGE_FIELD',
};
